"use strict";
function isNode() {
    return 'undefined' != typeof process && '[object process]' === Object.prototype.toString.call(process);
}
Object.defineProperty(exports, "__esModule", {
    value: !0
}), Object.defineProperty(exports, "isNode", {
    enumerable: !0,
    get: function() {
        return isNode;
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsL1BsYXRmb3JtLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIi8vIENoZWNrIGZvciBOb2RlIGVudmlyb25tZW50LCBmcm9tIEF4aW9zIGxpYnJhcnlcbmV4cG9ydCBmdW5jdGlvbiBpc05vZGUoKTogYm9vbGVhbiB7XG4gICAgcmV0dXJuIChcbiAgICAgICAgdHlwZW9mIHByb2Nlc3MgIT09ICd1bmRlZmluZWQnICYmXG4gICAgICAgIE9iamVjdC5wcm90b3R5cGUudG9TdHJpbmcuY2FsbChwcm9jZXNzKSA9PT0gJ1tvYmplY3QgcHJvY2Vzc10nXG4gICAgKVxufVxuIl0sIm5hbWVzIjpbImlzTm9kZSIsInByb2Nlc3MiLCJPYmplY3QiLCJwcm90b3R5cGUiLCJ0b1N0cmluZyIsImNhbGwiXSwibWFwcGluZ3MiOiI7QUFDTyxTQUFTQTtJQUNaLE9BQ0ksQUFBbUIsZUFBbkIsT0FBT0MsV0FDUEMsQUFBNEMsdUJBQTVDQSxPQUFPQyxTQUFTLENBQUNDLFFBQVEsQ0FBQ0MsSUFBSSxDQUFDSjtBQUV2Qzs7O21DQUxnQkQ7OztlQUFBQSJ9